import { useFormik } from "formik";
import {
  formikSetup,
  formikValidation,
  initialValues,
  validationSchema,
} from "../auth/formikValidation";
import StartPage from "../reusableComponents/startPage";
import TextInput from "./../sharedComponents/inputs/textInput";
import Lang from "../../userPreferences/staticWords";
import Button from "../sharedComponents/buttons/button";
import { useNavigate, useLocation } from "react-router-dom";
import { resetPassword } from "../../API/store/actions/auth";

const ResetPassword = () => {
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const navigate = useNavigate();

  const submit = async (values) => {
    let res = await resetPassword(
      values.email,
      values.password,
      query.get("code").replace(" ", "+")
    );
    if (res.status <= 206) {
      navigate("/");
    }
  };

  const formik = useFormik(
    formikSetup(initialValues, {}, validationSchema, "resetPassword", submit)
  );
  const { errors, touched, handleSubmit, handleChange, values } = formik;
  return (
    <StartPage title={"كلمة مرور جديدة"}>
      <form onSubmit={handleSubmit} style={{ display: "contents" }}>
        <div className="mx-2 my-3 d-flex flex-column justify-content-center align-items-center">
          <TextInput
            name={"email"}
            value={values.email}
            onChange={handleChange}
            errorMessage={formikValidation(touched, errors, "email")}
            type={"text"}
            hiddenPlaceholder={Lang.mail}
            containerStyle={"col-lg-6 col-md-8 col-12 my-2"}
            style={{ textAlign: "left" }}
          ></TextInput>
          <TextInput
            name={"password"}
            value={values.password}
            onChange={handleChange}
            errorMessage={formikValidation(touched, errors, "password")}
            type={"password"}
            hiddenPlaceholder={Lang.password}
            containerStyle={"col-lg-6 col-md-8 col-12 my-2"}
            style={{ textAlign: "left" }}
          ></TextInput>
        </div>
        <div className="col-12 p-0 d-flex justify-content-center">
          <Button
            type={"submit"}
            buttonStyleType={"solid"}
            content={"تاكيد"}
            containerStyle={"col-lg-2 col-md-4 col-6 mx-3 mb-2"}
          />
        </div>
      </form>
    </StartPage>
  );
};

export default ResetPassword;
